import { RESOURCE_COLOR_MAP } from "@/constants/resource-const"
import { Fragment } from "react"
import { useParams } from "react-router-dom"
import { RESOURCE_OVERUSE_META } from "./monitoring-const"

const MonitoringRealtimeStatus = ({
  summary,
  selectedDong,
  onHoverResource,
  selectedResource,
  onSelectResource
}) => {
  const { aptCode } = useParams()

  const counts = RESOURCE_OVERUSE_META.reduce((acc, { key }) => {
    acc[key] = 0
    return acc
  }, {})

  if (selectedDong === "all") {
    Object.values(summary ?? {}).forEach((dongSummary) => {
      RESOURCE_OVERUSE_META.forEach(({ key }) => {
        counts[key] += dongSummary[key] ?? 0
      })
    })
  } else {
    const dongSummary = summary?.[selectedDong]

    if (dongSummary) {
      RESOURCE_OVERUSE_META.forEach(({ key }) => {
        counts[key] = dongSummary[key] ?? 0
      })
    }
  }

  const total = Object.values(counts).reduce((sum, count) => sum + count, 0)

  return (
    <section className="flex flex-col h-full">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800">실시간 현황</h2>

        <p className="mt-1 text-xs text-gray-400">
          {selectedDong === "all"
            ? "단지 전체의 현재 상태입니다"
            : `${selectedDong}동의 현재 상태입니다`}
        </p>
      </div>

      <article className="flex-1 space-y-1" onMouseLeave={() => onHoverResource("")}>
        {RESOURCE_OVERUSE_META.map(({ key, label }) => {
          const count = counts[key]
          const color = RESOURCE_COLOR_MAP[key]

          if (aptCode === "A10020025" && ["hotwater", "hot"].includes(key)) {
            return <Fragment key={key} />
          }

          return (
            <button
              key={key}
              className={`
                ${selectedResource === key ? "bg-gray-200/80" : "hover:bg-gray-100"}
                flex w-full cursor-pointer items-center justify-between
                rounded-xl px-3 py-2.5 
              `}
              onMouseEnter={() => onHoverResource(key)}
              onClick={() => onSelectResource(selectedResource === key ? "" : key)}
            >
              <div className="flex items-center gap-2.5">
                <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: color }} />

                <span className="text-sm font-medium text-gray-600">{label}</span>
              </div>

              <span
                className={`text-sm font-bold ${count > 0 ? "text-gray-800" : "text-gray-300"}`}
              >
                {count}
                <span className="ml-0.5 text-xs font-normal text-gray-400">건</span>
              </span>
            </button>
          )
        })}
      </article>

      <article className="mt-2 border-t border-gray-100 pt-3">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-500">전체 이상</span>

          <span className="text-xl font-bold text-gray-800">
            {total}
            <span className="ml-1 text-xs font-normal text-gray-400">건</span>
          </span>
        </div>
      </article>
    </section>
  )
}

export default MonitoringRealtimeStatus
